import React from 'react'
import FlowerProductsContext, { IFlowerProductsContext } from '../../contexts/FlowerProductsContext'

const useFlowerProductsContext = (): IFlowerProductsContext => {
  const ctx = React.useContext(FlowerProductsContext)

  if (!ctx.isChildOfProvider) {
    throw new Error(
      '"useFlowerProductsContext" must be used as a child of the flower products context provider',
    )
  }

  return ctx
}

export default useFlowerProductsContext
